// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"fd9a9d3d","339":"87e47d91","453":"03346f77","551":"8912905c","640":"7ffd70eb"}[chunkId] + ".chunk.js";
};